import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getNoteHistory,
  getPatientsVisitDetailsByVisitId,
  getProgressNoteConvertV2,
  getProgressNoteImage,
  getProgressNoteTemplates,
  getVisitCharts,
  getVisitDiagnosis,
  getVisitProcedures,
} from 'src/helper/backendHelper'
import { fetchMips } from '../../helper/mipsHelper'
import { getFusion } from '../../apiHelper/fusionApi'
import FEATURES from '../../utils/featuresConstants'

export const getInitialPayload = createAsyncThunk(
  'getProgressNote/initialPayload',
  async (visitid, thunkAPI) => {
    try {
      const results = await Promise.allSettled([
        getProgressNoteTemplates(),
        getVisitDiagnosis(visitid),
        getVisitProcedures(visitid),
        getPatientsVisitDetailsByVisitId(visitid),
        getVisitCharts(visitid),
        fetchMips({
          charge_id: visitid,
        }),
      ])

      const [
        resProgressNoteTemplate,
        resDiagnosis,
        resProcedures,
        resVisitDetail,
        resCurrentChart,
        fetchedMips,
      ] = results.map((result) => {
        if (result.status === 'fulfilled') {
          return result.value
        }
        console.error(result.reason)
        return null
      })

      thunkAPI.dispatch(getProgressNoteHistory(resVisitDetail?.result?.[0]?.patient_id))

      let chartData = resCurrentChart?.data

      if (!chartData?.from_v2) {
        const v2ChartRes = await getProgressNoteConvertV2(visitid)

        if (v2ChartRes) {
          chartData = v2ChartRes
        }
      }

      if (resProgressNoteTemplate?.status === 500) {
        return thunkAPI.rejectWithValue('Server Error')
      } else {
        let initialObject = {}
        if (resProgressNoteTemplate?.status === 'success') {
          let {
            user: { features },
          } = thunkAPI.getState()
          initialObject = {
            features: features || [],
            // unused
            templates: resProgressNoteTemplate?.results,
            mips: fetchedMips,
            visitDetail: resVisitDetail?.result?.[0],
            diagnosisData: resDiagnosis?.results,
            proceduresData:
              resProcedures?.results?.map((cpt) => ({
                ...cpt,
                code: cpt.code + '',
              })) || [],
          }
        }

        if (resCurrentChart?.status === 'success' && resVisitDetail?.status === 'success') {
          initialObject = {
            ...initialObject,
            chartData: chartData,
          }
        }

        return initialObject
      }
    } catch (err) {
      return err?.message
    }
  },
)

export const getAiPredictions = createAsyncThunk('getAiPredictions', async (_, thunkAPI) => {
  let {
    user: { features },
    progressNote: { chartId },
  } = thunkAPI.getState()
  if (chartId && features.includes(FEATURES.DesktopAI)) {
    const res = await getFusion('v1/chart/inspect/' + chartId)

    if (res?.status !== 'success') {
      console.error(res)
      return null
    } else {
      return res.data
    }
  }
  return null
})

export const getProgressNoteHistory = createAsyncThunk(
  'getProgressNoteHistory',
  async (patientId) => {
    if (patientId) {
      const res = await getNoteHistory(patientId)

      if (res?.status !== 'success') {
        console.error(res)
      } else {
        return res.resData
      }
    }
  },
)
